import React from "react";
import Transition from "../../../../client/common/Transition/Animation";
import PropTypes from "prop-types";
import style from "./index.scss";

const URLShare = () => {
  const onSubmit = () => {};
  return (
    <Transition>
      <div className={style["urlshare"]}>
        <div className={style["share-body"]}>
          <div className={style["text-area-holder"]}>
            <label className={style["label"]}>Paste the Text Here</label>
            <input
              className={style["text-area"]}
              type="text"
              name="URL Share Text Area"
              placeholder={"Paste the text here"}
            />
          </div>
          <div className={style["btn-holder"]}>
            <div className={style["submit-btn"]} onClick={onSubmit}>
              Submit
            </div>
          </div>
        </div>
      </div>
    </Transition>
  );
};

URLShare.propTypes = {};

export default URLShare;
